import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import styled from '@emotion/styled';
import { AccountNavigationLink } from 'src/domains/layouts/webview/components/accountNavigationLink/AccountNavigationLink';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

interface LinkWrapperType {
    variant: DefaultComponentVariantType | null;
}

const setLinkWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.large} 0;
            margin: 0 16px;
        `;
    }
    return css`
        padding: 14px ${theme.star.padding.large};
        margin-bottom: 1px;
    `;
};

export const LinkWrapper = withConfig(theme => styled(AccountNavigationLink, { label: 'LinkWrapper' })<LinkWrapperType>`
    ${({ variant }): SerializedStyles => setLinkWrapper(variant, theme)}
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.star.accountLinks.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.43;
    text-decoration: none;
    position: relative;
    &::after {
        background-color: ${theme.star.accountLinks.borderColor};
        content: '';
        display: block;
        height: 1px;
        left: 0;
        position: absolute;
        top: 100%;
        width: 100%;
    }
    &:last-child::after {
        content: none;
    }
`);

export const Arrow = styled(ChevronIcon, { label: 'Arrow' })`
    fill: currentcolor;
    width: 12px;
`;
